import React from 'react';
import _ from 'lodash';

import Big from 'big.js';
import { useLineItemUnbundlerWidgetQuery } from 'generated/graphql';



export interface ILineItemUnbundler {
  id: string;
  sku: string;
  productName: string;
  priceCents: Big;
  value: string;
  comparisonOperator: string;
}

export interface IData {
  rules: ILineItemUnbundler[];
}

export function useQuery(storeId: string) {
  const tuple = useLineItemUnbundlerWidgetQuery({
    variables: {
      storeId
    }
  });

  return React.useMemo(
    () => {
      const data: IData = {
        rules: _.map(tuple.data?.lineItemUnbundlingRules.nodes ?? [], (node): ILineItemUnbundler => ({
          id: node.id,
          priceCents: new Big(node.priceCents),
          productName: node.productName,
          sku: node.sku,
          value: node.value,
          comparisonOperator: node.comparisonOperator.displayName
        }))
      };

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
